import { render } from "./ToastsContainer.vue?vue&type=template&id=ec1ce624&scoped=true"
import script from "./ToastsContainer.vue?vue&type=script&lang=ts"
export * from "./ToastsContainer.vue?vue&type=script&lang=ts"

import "./ToastsContainer.vue?vue&type=style&index=0&id=ec1ce624&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-ec1ce624"

export default script